import { render, staticRenderFns } from "./ConvoCommentStatements.vue?vue&type=template&id=7b5be477&"
import script from "./ConvoCommentStatements.vue?vue&type=script&lang=js&"
export * from "./ConvoCommentStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports